export class AreaDocsAnalytics {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Read
    async getDocsPageAnalytics(designSystemId, versionId, timeFrames) {
        const mappedTimeFrames = timeFrames.map((t) => {
            return {
                start: t.start,
                end: t.end ? t.end : undefined,
            };
        });
        return this.dataCore.docsPageAnalytics(designSystemId, versionId, mappedTimeFrames);
    }
}
